import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import * as HttpStatus from 'http-status-codes';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { ResponseUtil } from './response-util';
import { LogService } from '../log/log.service';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';

@Injectable()
export class ResponseUtilService {
  constructor(
    private authStore: AuthenticationStore,
    private logService: LogService,
    private flashMessagesService: FlashMessagesService) {
  }

  handleError(response: Response | Error): Observable<Response> {
    if ((response instanceof Response && (<Response>response).status === HttpStatus.UNAUTHORIZED)
      || response instanceof Error) {
      this.authStore.logout();
      this.logService.warn('Logging out due to AuthHttp error or invalid JWT token');
      this.logService.warn(response.toString());
      // return empty since we handled the error
      return Observable.empty();
    } else if (response instanceof Response && (<Response>response).status === HttpStatus.INTERNAL_SERVER_ERROR) {
      this.flashMessagesService.error('MESSAGES.ERROR.INTERNAL_SERVER_ERROR', 'An unexpected error has occurred');
      return Observable.empty();
    } else { // must be Response without status code 401
      return ResponseUtil.unwrapErrorMessage(response);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/utils/response-util.service.ts